(function () {
  'use strict';

  const ISTANBUL_TZ = 'Europe/Istanbul';
  const OFFICIAL_HOLIDAYS = [
    '2026-01-01',
    '2026-03-19',
    '2026-03-20',
    '2026-03-21',
    '2026-03-22',
    '2026-04-23',
    '2026-05-01',
    '2026-05-19',
    '2026-05-26',
    '2026-05-27',
    '2026-05-28',
    '2026-05-29',
    '2026-05-30',
    '2026-07-15',
    '2026-08-30',
    '2026-10-28',
    '2026-10-29',
    '2027-01-01',
    '2027-03-08',
    '2027-03-09',
    '2027-03-10',
    '2027-03-11',
    '2027-04-23',
    '2027-05-01',
    '2027-05-15',
    '2027-05-16',
    '2027-05-17',
    '2027-05-18',
    '2027-05-19',
    '2027-07-15',
    '2027-08-30',
    '2027-10-28',
    '2027-10-29',
    '2028-01-01',
    '2028-02-25',
    '2028-02-26',
    '2028-02-27',
    '2028-02-28',
    '2028-04-23',
    '2028-05-01',
    '2028-05-04',
    '2028-05-05',
    '2028-05-06',
    '2028-05-07',
    '2028-05-08',
    '2028-05-19',
    '2028-07-15',
    '2028-08-30',
    '2028-10-28',
    '2028-10-29',
  ];

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function addDays(date, days) {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  }

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function toDateStr(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function getIstanbulNow(baseDate) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: ISTANBUL_TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(baseDate || new Date());
    const values = {};

    parts.forEach((part) => {
      values[part.type] = part.value;
    });

    const year = Number(values.year);
    const month = Number(values.month);
    const day = Number(values.day);
    const hour = Number(values.hour);
    const minute = Number(values.minute);
    const second = Number(values.second);
    const date = new Date(year, month - 1, day, hour, minute, second);

    return {
      date,
      hours: hour,
      minutes: minute,
      dateStr: `${values.year}-${values.month}-${values.day}`,
    };
  }

  function parseHolidaySet(raw) {
    const holidays = new Set(OFFICIAL_HOLIDAYS);

    String(raw || '')
      .split(/[\s,]+/)
      .map((entry) => entry.trim())
      .filter((entry) => /^\d{4}-\d{2}-\d{2}$/.test(entry))
      .forEach((entry) => holidays.add(entry));

    return holidays;
  }

  function parseBrandList(raw) {
    return String(raw || '')
      .split(',')
      .map((entry) => entry.trim())
      .filter(Boolean);
  }

  function normalizeTurkish(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i');
  }

  function isBusinessDay(date, holidays) {
    const day = date.getDay();

    if (day === 0 || day === 6) {
      return false;
    }

    return !holidays.has(toDateStr(date));
  }

  function readConfig() {
    const element = document.querySelector('[data-bh-cart-config]');
    const dataset = element ? element.dataset : {};

    return {
      cutoffHour: parseInt(dataset.bhCutH, 10) || 15,
      cutoffMinute: parseInt(dataset.bhCutM, 10) || 0,
      holidays: parseHolidaySet(dataset.bhHols || ''),
      warehouseBrands: parseBrandList(dataset.bhWh || ''),
    };
  }

  function isWarehouseVendor(vendor, config) {
    const runtimeConfig = config || readConfig();
    const normalizedVendor = normalizeTurkish(vendor);

    return runtimeConfig.warehouseBrands.some((brand) => normalizeTurkish(brand) === normalizedVendor);
  }

  function resolveLeadTime(rawLeadTime) {
    const normalized = String(rawLeadTime == null ? '' : rawLeadTime).trim();
    const lower = normalized.toLocaleLowerCase('tr-TR');

    if (!normalized) {
      return { kind: 'days', days: 1 };
    }

    if (lower === 'onsatis' || lower === 'ön satış' || lower === 'on satis') {
      return { kind: 'preorder' };
    }

    let days = parseInt(normalized, 10);

    if (Number.isNaN(days)) {
      days = 1;
    }

    if (days < 0) {
      days = 0;
    }

    if (days > 30) {
      days = 30;
    }

    return { kind: 'days', days };
  }

  function getShippingInfo(rawLeadTime, options) {
    const runtimeConfig = (options && options.config) || readConfig();
    const leadTime = resolveLeadTime(rawLeadTime);

    if (leadTime.kind === 'preorder') {
      return {
        kind: 'preorder',
        leadDays: null,
        shipDate: null,
        dayDiff: null,
      };
    }

    const now = getIstanbulNow(options && options.now);
    const today = startOfDay(now.date);
    let shipDate = new Date(today);
    const cutoffPassed =
      now.hours > runtimeConfig.cutoffHour
      || (now.hours === runtimeConfig.cutoffHour && now.minutes > runtimeConfig.cutoffMinute);

    if (leadTime.days === 0) {
      if (!isBusinessDay(shipDate, runtimeConfig.holidays) || cutoffPassed) {
        shipDate = addDays(shipDate, 1);
      }
    } else {
      shipDate = addDays(shipDate, leadTime.days);
    }

    let safety = 0;
    while (!isBusinessDay(shipDate, runtimeConfig.holidays) && safety < 60) {
      shipDate = addDays(shipDate, 1);
      safety += 1;
    }

    const dayDiff = Math.round((startOfDay(shipDate) - today) / 86400000);
    let kind = 'later';

    if (dayDiff === 0) {
      kind = 'today';
    } else if (dayDiff === 1) {
      kind = 'tomorrow';
    }

    return {
      kind,
      leadDays: leadTime.days,
      shipDate,
      dayDiff,
      cutoffPassed,
    };
  }

  function formatDayName(date, uppercase) {
    const value = new Intl.DateTimeFormat('tr-TR', { weekday: 'long' }).format(date);
    return uppercase ? value.toLocaleUpperCase('tr-TR') : value.charAt(0).toLocaleUpperCase('tr-TR') + value.slice(1);
  }

  function formatLongDate(date) {
    const parts = new Intl.DateTimeFormat('tr-TR', {
      day: 'numeric',
      month: 'long',
      weekday: 'long',
    }).formatToParts(date);

    return parts
      .filter((part) => part.type !== 'literal')
      .map((part) => part.value)
      .join(' ');
  }

  function formatBadgeLabel(info) {
    if (info.kind === 'preorder') {
      return 'ÖN SİPARİŞ';
    }

    if (info.kind === 'today') {
      return 'BUGÜN KARGODA';
    }

    if (info.kind === 'tomorrow') {
      return 'YARIN KARGODA';
    }

    return `${formatDayName(info.shipDate, true)} KARGODA`;
  }

  function formatCartLabel(info, labels) {
    const text = labels || {};

    if (info.kind === 'preorder') {
      return text.preorder || 'Ön sipariş ürünü - tedarik sürecinde kargoya verilecek.';
    }

    if (info.kind === 'today') {
      return text.today || 'Bugün kargoda';
    }

    if (info.kind === 'tomorrow') {
      return text.tomorrow || 'Yarın kargoda';
    }

    return `${formatLongDate(info.shipDate)} kargoda`;
  }

  function formatProductMessage(info, vendor, options) {
    const runtimeConfig = (options && options.config) || readConfig();
    const safeVendor = escapeHtml(vendor || '');
    const warehouseVendor = isWarehouseVendor(vendor, runtimeConfig);
    const suffix = warehouseVendor
      ? 'Bonherre tarafından kargoya verilir.'
      : `Bonherre adına <strong>${safeVendor}</strong> tarafından kargoya verilir.`;

    if (info.kind === 'preorder') {
      return 'Bu ürün <strong>Ön Sipariş</strong>tir. (20 İş Günü)';
    }

    if (info.kind === 'today') {
      return `Siparişiniz <strong>bugün</strong>, ${suffix}`;
    }

    if (info.kind === 'tomorrow') {
      return `Siparişiniz <strong>yarın</strong>, ${suffix}`;
    }

    if ((info.leadDays || 0) > 3) {
      return `Siparişiniz <strong>${formatLongDate(info.shipDate)}</strong> günü, ${suffix}`;
    }

    return `Siparişiniz <strong>${formatDayName(info.shipDate, false)}</strong> günü, ${suffix}`;
  }

  function initShippingBadges(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const nodes = scope.querySelectorAll('[data-bh-shipping-badge]');

    nodes.forEach((node) => {
      const label = node.querySelector('[data-bh-shipping-label]');
      if (!label) return;

      const info = getShippingInfo(node.dataset.bhShippingDays || '0');
      label.textContent = formatBadgeLabel(info);
    });
  }

  function initProductShipping(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const nodes = scope.querySelectorAll('[data-bh-product-shipping]');

    nodes.forEach((node) => {
      const available = node.dataset.bhAvailable !== 'false';

      if (!available) {
        node.classList.add('sold-out-mode');
        node.innerHTML = '<span>Bu ürün tükendi. Stok durumu için <strong>iletişime geçebilir</strong> veya <strong>bildirim listesine</strong> ekleyebilirsiniz.</span>';
        return;
      }

      node.classList.remove('sold-out-mode');

      const info = getShippingInfo(node.dataset.bhShippingDays || '1');
      const vendor = node.dataset.bhVendor || '';
      node.innerHTML = `<span>${formatProductMessage(info, vendor)}</span>`;
    });
  }

  window.BHShipping = {
    OFFICIAL_HOLIDAYS,
    parseHolidaySet,
    readConfig,
    isWarehouseVendor,
    getShippingInfo,
    formatBadgeLabel,
    formatCartLabel,
    formatProductMessage,
    initShippingBadges,
    initProductShipping,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initShippingBadges();
      initProductShipping();
    });
  } else {
    initShippingBadges();
    initProductShipping();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initShippingBadges(event.target);
    initProductShipping(event.target);
  });

  document.addEventListener('bh:recently-viewed:hydrated', function () {
    initShippingBadges();
  });

  document.addEventListener('bh:product-recommendations:hydrated', function (event) {
    initShippingBadges(event.target);
  });

  if (!window.__bhShippingRefreshTimer) {
    window.__bhShippingRefreshTimer = window.setInterval(function () {
      initShippingBadges();
      initProductShipping();
    }, 60000);
  }
})();
